import React, { useEffect, useState } from 'react';
import InputControl from '../../../components/InputControl/InputControl';
import { connect } from 'react-redux';
import { Dispatch } from '../../../store/store';
import { ICustomChannelName } from '../../../types/channel-types';

const ChannelNames: React.FC = ({
  getCustomChannelNames,
  saveCustomChannelNames,
  cycleId
}: {
  getCustomChannelNames: (cycleId: string) => Promise<ICustomChannelName[]>,
  saveCustomChannelNames: ({ cycleId, customChannelNames }: { cycleId: string, customChannelNames: ICustomChannelName[] }) => void,
  cycleId: string
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [channelNames, setChannelNames] = useState<ICustomChannelName[]>([]);
  const handleChange = (channel: ICustomChannelName, value: string) => {
    setChannelNames(prev => prev.map(ch =>
      ch.original === channel.original
        ? { ...ch, custom: value }
        : ch
    ));
  };

  const handleSave = async () => {
    if (!channelNames.length) return;

    try {
      setIsLoading(true);
      // Filter out channels with empty custom names
      const filteredChannelNames = channelNames.filter(channel =>
        channel.custom && channel.custom.trim() !== ''
      );

      await saveCustomChannelNames({
        cycleId,
        customChannelNames: filteredChannelNames
      });
    } catch (error) {
      console.error('Error saving channel name:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchChannelNames = async () => {
      const names = await getCustomChannelNames(cycleId);
      setChannelNames(names);
    };

    fetchChannelNames();
  }, [cycleId]);

  return (
    <div className="c-channel-name my-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="border-b border-stroke px-7 py-4 dark:border-strokedark">
        <h3 className="font-medium text-black dark:text-white">Channel Names</h3>
      </div>

      <div className="p-7">
        {channelNames?.map((channel) => (
          <div key={channel.original} className="flex items-center gap-4 mb-4">
            <div className="w-1/2 pb-6">
              <span>{channel.fromDynamo || channel.original}:</span>
            </div>
            <div className="w-1/2">
              <InputControl
                placeholder="Enter channel name"
                value={channel.custom || ''}
                onChange={(e) => handleChange(channel, e.target.value)}
              />
            </div>
          </div>
        ))}

        <div className="mt-5.5">
          <button
            onClick={handleSave}
            className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-2 text-center font-medium text-white hover:bg-opacity-90 disabled:opacity-50"
            disabled={isLoading || !channelNames.length}
          >
            {isLoading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatch = (dispatch: Dispatch) => ({
  getCustomChannelNames: dispatch.reports.getCustomChannelNames,
  saveCustomChannelNames: dispatch.reports.saveCustomChannelNames,
});


export default connect(null, mapDispatch)(ChannelNames);